import './App.css';
import Login from './pages/Login';
import React from "react";
import { Routes, Route } from "react-router-dom";
import DashboardLayout from './components/DashboardLayout';
import Profile from './pages/Profile';
import RequireAuth from "./RequireAuth";
import Rf from "./pages/Rf";
import Events from "./pages/Events";
import Vendors from "./pages/Vendors";
import Approval from "./pages/Approval";
import Bank from "./pages/Bank";
import Account from "./pages/Account";
import Register from "./pages/Register";
import FilteredRf from "./pages/FilteredRf";
import RfDetails from "./pages/RfDetails";
import Create from "./pages/Create";
import UpdateRf from "./pages/UpdateRf"; 
import Dashboard from './pages/Dashboard';
import NProgress from "nprogress";
import 'nprogress/nprogress.css';

NProgress.configure({ showSpinner: true });

function App() {
  
  return (
    <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="register" element={<Register />} />
        {/* Layout dengan sidebar dan navbar */}
        <Route path="/" element={
          <RequireAuth>
           <DashboardLayout />
          </RequireAuth>}>
          <Route path="/" element={<Rf />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="profile" element={<Profile />} />
          <Route path="events" element={<Events />} />
          <Route path="vendors" element={<Vendors />} />
          <Route path="approval" element={<Approval />} />
          <Route path="bank" element={<Bank />} />
          <Route path="account" element={<Account />} />
          <Route path="filteredRf" element={<FilteredRf />} />
          <Route path="detail/:id" element={<RfDetails />} />
          <Route path="create" element={<Create />} />
          <Route path="updateRf/:id" element={<UpdateRf />} />
        </Route>
      </Routes>
  );
}

export default App;
